<template>
  <v-layer
    ref="grid"
    name="gridLayer"
    :listening="false"
    :config="{
      clipX: 0,
      clipY: 0,
      clipWidth: patternConfig.width + patternConfig.rulerSize,
      clipHeight: patternConfig.height + patternConfig.rulerSize,
      thumbnailConfig: {
        bgColor: gridBgColor,
        width: patternConfig.width + patternConfig.rulerSize,
        height: patternConfig.height + patternConfig.rulerSize,
      },
      x: 0,
      y: 0,
    }"
  >
    <v-rect
      v-if="gridPatternAsImage"
      :config="gridPatternAsImage"
      :listening="false"
    />
    <LazyCanvasGridSquareLayer
      v-if="!gridPatternAsImage && gridPattern.id === 'square'"
      :config="patternConfig"
      @pattern-updated="handleUpdate"
    />
    <LazyCanvasGrid45degLayer
      v-if="!gridPatternAsImage && gridPattern.id === '45-deg'"
      :config="patternConfig"
      @pattern-updated="handleUpdate"
    />
    <LazyCanvasGridHexLayer
      v-if="!gridPatternAsImage && gridPattern.id === 'hex'"
      :config="patternConfig"
      @pattern-updated="handleUpdate"
    />
    <LazyCanvasGridHex90Layer
      v-if="!gridPatternAsImage && gridPattern.id === 'hex-90'"
      :config="patternConfig"
      @pattern-updated="handleUpdate"
    />
    <LazyCanvasGridHexSpacedLayer
      v-if="!gridPatternAsImage && gridPattern.id === 'hex-spaced'"
      :config="patternConfig"
    />
    <LazyCanvasGridFreeformLayer
      v-if="!gridPatternAsImage && gridPattern.id === 'freeform'"
      :config="patternConfig"
    />
    <LazyCanvasGrid3DLayer
      v-if="!gridPatternAsImage && gridPattern.id === '3d'"
      :config="patternConfig"
      @pattern-updated="handleUpdate"
    />
  </v-layer>
</template>

<script setup>
const grid = ref(null)
const gridPatternAsImage = ref(null)
const updateAfterMounted = ref(false)
const store = useGridStore();
const { gridWidth, gridHeight, footInPx, gridBgColor, gridPattern, startOffset, gridPos, gridZoom } = storeToRefs(store);

const patternConfig = computed(() => ({
  width: gridWidth.value,
  height: gridHeight.value,
  footInPx: footInPx.value,
  bgColor: gridBgColor.value,
  padding: gridPattern.value.padding,
  snap: gridPattern.value.snap,
  rulerSize: startOffset.value,
  rulerTextColor: "#5E5E5E",
}));

const handleUpdate = async () => {
  const stage = grid.value.getNode().clone().getStage()

  if (!stage) {
    updateAfterMounted.value = true
    return
  }

  console.log("Converting Grid Pattern Layout to image...")

  const imageConfig = {
    x: 0,
    y: 0,
    width: patternConfig.value.width + patternConfig.value.rulerSize,
    height: patternConfig.value.height + patternConfig.value.rulerSize,
    pixelRatio: 2,
  }

  try {
    const originalScale = stage.getScale()
    const originalPosition = stage.getPosition()
    stage.scale({ x: 1, y: 1 }).position({ x: 0, y: 0 })
    const layer = grid.value.getNode().getLayer()
    const image = await layer.toImage(imageConfig)
    stage.scale(originalScale).position(originalPosition)

    gridPatternAsImage.value = {
      ...imageConfig,
      fillPatternImage: image,
      fillPatternRepeat: 'no-repeat',
      fillPatternScale: { x: 0.5, y: 0.5 },
    }

    console.log("Grid Pattern Layout converted to image.")
  } catch (e) {
    gridPatternAsImage.value = null
    console.warn('Unable to generate static image from grid pattern', e)
  }
}

watch(patternConfig, () => {
  gridPatternAsImage.value = null
})

onMounted(() => {
  console.log("[Pattern Layer]", gridPattern.value.id);
  if (updateAfterMounted.value) handleUpdate()
});
</script>
